/*global WeixinJSBridge*/
import React, { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import weui from "weui.js";
import { payService } from "../../services";
import { urls } from "../../urls";
import { PayChannels, getAxiosError } from "../../utils";

/**
 * 微信用户授权回调页面, 用于获取返回的 code 并调用后端接口生成微信支付订单
 * 支持微信/汇付天下微信
 */
export const TenPay = props => {
  const navigate = useNavigate();
  const [qs, setQs] = useSearchParams();
  const code = useMemo(() => qs.get("code"), [qs]);
  const [channel, orderNo] = useMemo(() => qs.get("state").split(","), [qs]);
  
  // 发起微信支付
  const invokeTenPay = useCallback((data) => {
    const onBridgeReady = () => {
      /* data 格式:
      {
        "appId": "wx2421b1c4370ec43b",     //公众号ID，由商户传入     
        "timeStamp": "1395712654",     //时间戳，自1970年以来的秒数     
        "nonceStr": "e61463f8efa94090b1f366cccfbbb444",      //随机串     
        "package": "prepay_id=up_wx21201855730335ac86f8c43d1889123400",
        "signType": "RSA",     //微信签名方式：     
        "paySign": "oR9d8PuhnIc+YZ8cBHFCwfgpaK9gd7vaRvkYD7rthRAZ\/X+QBhcCYL21N7cHCTUxbQ+EAt6Uy+lwSN22f5YZvI45MLko8Pfso0jm46v5hqcVwrk6uddkGuT+Cdvu4WBqDzaDjnNa5UK3GfE1Wfl2gHxIIY5lLdUgWFts17D4WuolLLkiFZV+JSHMvH7eaLdT9N5GBovBwu5yYKUR7skR8Fu+LozcSqQixnlEZUfyE55feLOQTUYzLmR9pNtPbPsu6WVhbNHMS3Ss2+AehHvz+n64GDmXxbX++IOBvm2olHu3PsOUGRwhudhVf7UcGcunXt8cqNjKNqZLhLw4jq\/xDg==" //微信签名 
      }
      */
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, res => {
        let msg = null,
          url = urls.fee();
        if (res.err_msg === "get_brand_wcpay_request:ok") {
          url = urls.payResult(orderNo);
        } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
          msg = "支付操作已取消";
        } else if (res.err_msg === "get_brand_wcpay_request:fail") {
          msg = "支付失败";
        }
        
        if (msg) {
          weui.alert(msg, () => navigate(url));
        } else {
          navigate(url);
        }
      });
    };
    
    if (typeof WeixinJSBridge === "undefined") {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
        document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  }, [orderNo, navigate]);

  const reload = useCallback(async () => {
    const loading = weui.loading("加载中");
    try {
      let res;
      // 1_微信, 2_支付宝, 3_微信HF, 4_支付宝HF, 5_公对公HF
      switch (parseInt(channel)) {
      case PayChannels.TenPay:
        res = await payService.wechatPay(orderNo, code);
        invokeTenPay(res.data);
        break;
      case PayChannels.TenPayHF:
        res = await payService.wechatPayNSPOS(orderNo, code);
        invokeTenPay(res.data);
        break;
      default:
        weui.alert("无效的支付参数!", () => navigate(urls.fee()));
        break;
      }
    } catch (err) {
      weui.topTips(getAxiosError(err));
      navigate(urls.fee());
    } finally {
      loading.hide();
    }
  }, [channel, orderNo, code, invokeTenPay, navigate]);

  useEffect(() => {
    reload();
  }, [reload]);

  return <></>;
};
